<template>
  <!-- 添加服务人员 -->
  <div class="container">
    <div class="vue">
      <div class="header">
        <div class="text">{{ headText }}</div>
      </div>
      <div class="content flex">
        <div class="left"></div>
        <div class="right FZ0875">
          <div class="form flex">
            <span class="text">人员姓名</span>
            <el-input
              v-model="serveForm.servername"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex" v-if="editObj === ''">
            <span class="text">手机号</span>
            <el-input
              v-model="serveForm.tel"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex" v-if="editObj === ''">
            <span class="text">密码</span>
            <el-input
              v-model="serveForm.password"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class=" flex" v-else></div>
          <div class="form flex">
            <span class="text">服务类型</span>
            <el-select v-model="serveForm.serviceType" placeholder="请选择" @change="serviceTypeChange">
              <el-option
                v-for="item in serviceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="form flex">
            <span class="text">所属地区</span>
            <el-select v-model="serveForm.community" placeholder="请选择">
              <el-option
                v-for="item in communityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="form flex">
            <span class="text">擅长领域</span>
            <el-input
              v-model="serveForm.serviceSpecialize"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">照片</span>
            <div class="image">
              <el-upload
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :file-list="fileList"
                :on-remove="handleRemove"
                :limit="1"
                :http-request="uploadSectionFile"
                :on-exceed="handleExceed"
              >
                <div class="addimage flex">
                  <el-image
                    :src="require('@/assets/ProductManage/tjtp.png')"
                  ></el-image>
                  <span class="text">添加图片</span>
                </div>
              </el-upload>
              <!-- <div class="imagelist"></div> -->
            </div>
          </div>
          <div class="form flex" v-if="serveForm.serviceType == '养老服务'">
            <span class="text">工作时间</span>
            <el-checkbox-group v-model="canworktime" class="flex flexWrap">
              <el-checkbox label="不固定"></el-checkbox>
              <el-checkbox label="06:00-08:00"></el-checkbox>
              <el-checkbox label="08:00-10:00"></el-checkbox>
              <el-checkbox label="10:00-12:00"></el-checkbox>
              <el-checkbox label="12:00-14:00"></el-checkbox>
              <el-checkbox label="14:00-16:00"></el-checkbox>
              <el-checkbox label="16:00-18:00"></el-checkbox>
              <el-checkbox label="18:00-20:00"></el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="form flex submit">
            <span class="text"></span>
            <el-button
              v-if="editObj === ''"
              class="sure"
              size="small"
              type="primary"
              @click="confirmBut"
              >确认</el-button
            >
            <el-button
              v-else
              class="sure"
              size="small"
              type="primary"
              @click="editBut"
              >确认</el-button
            >
            <el-button class="sure" size="small" plain @click="cancelBut"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUploadByBase64 } from '@/api/uploading'
import { apiAddUser, apiEditServer } from '@/api/management'

let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      editObj: '', // 编辑的数据
      headText: '添加服务人员',
      uploadActionUrl: '',
      serveForm: {
        servername: '',
        tel: '',
        password: '',
        serviceSpecialize: '',
        server: 1, // 1为服务人员
        serviceType: '健康服务',
        community: '全部'
      },
      fileList: [], // 存储图片
      canworktime: ['不固定'], // 工作时间
      serviceTypeOptions: [{label:'健康服务', value:'健康服务'},{label:'健康管理', value:'健康管理'},{label: '养老服务', value: '养老服务'}],
      communityOptions: [{label:'全部', value:'全部'},{label:'南京', value:'南京'},{label:'苏州', value:'苏州'},{label:'无锡', value:'无锡'},
        {label:'徐州', value:'徐州'},{label:'常州', value:'常州'},{label:'南通', value:'南通'},{label:'盐城', value:'盐城'},
        {label:'扬州', value:'扬州'},{label:'镇江', value:'镇江'},{label:'泰州', value:'泰州'},{label:'淮安', value:'淮安'},
        {label:'宿迁', value:'宿迁'},{label:'连云港', value:'连云港'}],
      serveFormList: [
        '姓名不能为空！',
        '手机号不能为空！',
        '密码不能为空！',
        '擅长领域不能为空！',
        '角色类型不能为空！',
        // '工作时间不能为空！',
        '服务类型不能为空！'
      ],
      dialogVisible: false,
      imageUpload: '' // 教练照片
    }
  },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    if (this.$route.query.info !== undefined) {
      this.headText = '编辑服务人员'
      this.editObj = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.editObj)
      this.serveForm.tel = this.editObj.tel
      this.serveForm.servername = this.editObj.servername
      this.serveForm.serviceType = this.editObj.serviceType
      this.serveForm.serviceSpecialize = this.editObj.serviceSpecialize
      this.serveForm.community = this.editObj.community
      console.log(this.serveForm);
      if (this.editObj.image !== null) {
        _self.fileList = [{ url: this.editObj.image }]
      }
      console.log(this.fileList)
      this.canworktime = this.editObj.canWorkTime
    }
    //   uploadActionUrl
  },

  methods: {
    addimageBut() {
      alert('1111')
    },
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error('只能上传图片格式png、jpg、gif!')
        return
      }
      if (!isLt2M) {
        this.$message.error('只能上传图片大小小于2M')
        return
      }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function() {
        // const _self = this
        // this.result // 这个就是base64编码了
        const imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: imageUrl,
          path: 'serviceStaff'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            const list = {
              url: _self.baseImage + res.data
            }
            // _self.imageUpload = res.data
            _self.fileList[0] = list
          }
        })
      }
    },
    // 删除文件之前的钩子
    handleRemove() {
      _self.fileList = []
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      this.$message.error('最高可上传一个图片')
    },

    // 取消按钮
    cancelBut() {
      // 返回上一页
      this.$router.go(-1)
    },
    // 按钮
    // 添加--确定按钮
    confirmBut() {
      if (this.objNaN(this.serveForm, this.serveFormList) === false) {
        const canworktime = this.canworktime.toString()
        if (_self.fileList.length === 0) {
          this.$Me('照片不能为空！')
          return
        }
        console.log(_self.fileList)
        console.log(canworktime)
        if (_self.canworktime.length === 0) {
          this.$Me('工作时间不能为空！')
          return
        }
        apiAddUser({
          tel: this.serveForm.tel,    //手机号（账号）
          password: this.serveForm.password,    //密码
          servername: this.serveForm.servername,    //人员名字
          serviceSpecialize: this.serveForm.serviceSpecialize,   //擅长领域
          canworktime: canworktime,     //工作时间JSON（教练 / 服务人员）        不同
          image: _self.fileList[0].url,      //照片
          server: _self.serveForm.server,    //1为服务人员0为用户2为教练
          serviceType: _self.serveForm.serviceType,
          community: _self.serveForm.community
        }).then(res => {
          if (res.status === 0) {
            this.$Ms(res.msg)
            this.serveForm = {
              servername: '',
              tel: '',
              password: '',
              serviceSpecialize: '',
              server: 1, // 1为服务人员
              serviceType: '健康服务',
              community: '全部'
            }
            this.fileList = [] // 存储图片
            this.canworktime = [] // 存储图片
            this.$router.go(-1)
          } else if (res.status === 1) {
            this.$Me(res.msg)
          }
        })
      }
    },
    // 编辑--确定上传按钮
    editBut() {
      console.log(this.serveForm)
      console.log(this.canworktime)
      const canworktime = this.canworktime.toString()
      switch (true) {
        case this.serveForm.servername === '':
          this.$Me(this.serveFormList[0])
          break
        case this.serveForm.tel === '':
          this.$Me(this.serveFormList[1])
          break
        case this.serveForm.serviceSpecialize == '' ||
          this.serveForm.serviceSpecialize == null:
          this.$Me(this.serveFormList[3])
          break
        case this.fileList.length === 0:
          this.$Me(this.serveFormList[4])
          break
        case this.canworktime.length === 0 || this.canworktime == null:
          this.$Me(this.serveFormList[5])
          break
        case this.serveForm.serviceType === '':
          this.$Me(this.serveFormList[6])
          break
        default:
          apiEditServer({
            id: this.editObj.id,
            tel: this.serveForm.tel,
            servername: this.serveForm.servername,
            serviceSpecialize: this.serveForm.serviceSpecialize,
            canworktime: canworktime,
            image: this.fileList[0].url,
            server: this.serveForm.server,
            serviceType: this.serveForm.serviceType,
            community: this.serveForm.community
          }).then(res => {
            if (res.status === 0) {
              this.$Ms(res.msg)
              this.$router.go(-1)
            } else if (res.status === 1) {
              this.$Me(res.msg)
            }
          })

          break
      }
    },
    w() {
      apiUploadByBase64({
        base64: this.imageUrl,
        path: 'BackstageShop'
      }).then(res => {
        if (res.status === 0) {
          this.$message.success('文件上传成功')
        }
      })
    },
    serviceTypeChange() {
      if(this.serveForm.serviceType == '养老服务') {
        this.canworktime = [];
      } else {
        this.canworktime = ['不固定'];
      }
    },
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .left {
      width: 30%;
    }
    .right {
      width: 70%;
      .form {
        width: 100%;
        line-height: 3;
        // align-items: center;
        justify-content: flex-start;
        padding-bottom: 10px;
        text-align: right;
        .text {
          width: 13%;
          padding-right: 10px;
        }
        .sure {
          padding: 8px 28px;
        }
        .image {
          .addimage {
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .el-image {
              width: 30px;
              height: 30px;
            }
            .text {
              padding: 0;
              padding-top: 10px;
              width: 100%;
              line-height: normal;
            }
          }
          //   .left_name {
          //     width: 80px;
          //     height: 80px;
          //     border: 1px solid #e3e3e3;
          //     padding: 6px;
          //     flex-direction: column;
          //     align-items: center;
          //     justify-content: center;
          //     color: #858585;
          //   }
        }
        .el-input,
        .editor,
        .textarea {
          width: 87%;
        }
        .new-input {
          width: 28%;
          padding-right: 10px;
        }
      }
      .submit {
        padding-top: 20px;
      }
    }
  }
}
</style>
